






























































































































































































































import { Vue, Component } from "nuxt-property-decorator";
import GrPublicFooter from "~/components/startPageNew/GrPublicFooter.vue";
import MaxWidthSection from "~/components/common/MaxWidthSection.vue";
import GrButton from "~/components/common/GrButton.vue";
import TwoColumnRow from "~/components/common/TwoColumnRow.vue";
import MoreInfoCompaniesGrid from "~/components/common/MoreInfoCompaniesGrid.vue";
import WhatOurCustomersThink from "~/components/common/WhatOurCustomersThink.vue";
import BottomInterestForm from "~/components/common/BottomInterestForm.vue";
import MorePagesScroller from "~/components/common/MorePagesScroller.vue";
import CommonQuestionsCompany from "~/components/common/CommonQuestionsCompany.vue";
import CompanyStartBreadcurmb from "~/components/common/CompanyStartBreadcurmb.vue";
import CommonQuestion from "~/components/common/CommonQuestion.vue";
import CompanyStartColumnInfoCard from "~/components/common/CompanyStartColumnInfoCard.vue";
import CompanyCitationCard from "~/components/company/CompanyCitationCard.vue";
import CTAButtonsCompany from "~/components/common/CTAButtonsCompany.vue";

// import gsap from "gsap";

@Component({
  layout: "companyPublicLayout",
  components: {
    GrPublicFooter,
    MaxWidthSection,
    GrButton,
    TwoColumnRow,
    MoreInfoCompaniesGrid,
    WhatOurCustomersThink,
    BottomInterestForm,
    MorePagesScroller,
    CommonQuestionsCompany,
    CompanyStartBreadcurmb,
    CommonQuestion,
    CompanyStartColumnInfoCard,
    CompanyCitationCard,
    CTAButtonsCompany,
  },
})
export default class FordomsfrihetPage extends Vue {
  head() {
    return {
      title: this.$t("Integrationer").toString(),
    };
  }

  questions = [
    {
      question: this.$t(
        "Kan Gritify hantera höga krav på IT-säkerhet?"
      ).toString(),
      isOpen: false,
      answer: this.$t(
        "Inga problem. Gritify används bl.a. för att rekrytera specialister inom IT-säkerhet och av företag som säljer tjänster inom området. Vi kan säkerligen tillfredsställa era behov av tvåstegsverifiering, datalagring och/eller liknande frågor."
      ).toString(),
    },
    {
      question: this.$t(
        "Kan jag samarbeta med mina kollegor i Gritify?"
      ).toString(),
      isOpen: false,
      answer: this.$t(
        "Självklart. Gritify är utvecklat för att passa en agil organisation som kan jobba utspritt och/eller vid olika tillfällen på dygnet. Är ni flera kollegor som arbetar i Gritify är det enkelt att tagga varandra med meddelanden. Behöver ni samarbeta med kollegor som inte använder Gritify är det smidigt att dela information med dessa som gör att de inte behöver skapa login och bekanta sig med Gritify."
      ).toString(),
    },
    {
      question: this.$t("Är Gritify tillgängligt på flera språk?").toString(),
      isOpen: false,
      answer: this.$t(
        "Gritify finns tillgängligt på både svenska och engelska. Språket anpassas automatiskt efter användarens inställningar i webbläsaren men kan enkelt ändras vid behov."
      ).toString(),
    },
    {
      question: this.$t("Kan jag få support vid behov?").toString(),
      isOpen: false,
      answer: this.$t(
        "Absolut. Är ni kund på Gritify har ni alltid tillgång till vår Customer Succes. Vi hjälper er med det ni behöver för att bli framgångsrika, oavsett om det är marknadsdata, rådgivning kring strategi i en enskild rekrytering eller något annat."
      ).toString(),
    },
  ];
}
